"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return FormView;
    }
});
const _models = require("~/models");
const _FormViewColumn = /*#__PURE__*/ _interop_require_default(require("~/models/FormViewColumn"));
const _View = /*#__PURE__*/ _interop_require_default(require("~/models/View"));
const _extractProps = require("~/helpers/extractProps");
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _serialize = require("~/utils/serialize");
const _globals = require("~/utils/globals");
const _modelUtils = require("~/utils/modelUtils");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let FormView = class FormView {
    static async get(context, viewId, ncMeta = _Noco.default.ncMeta) {
        let view = viewId && await _NocoCache.default.get(context, `${_globals.CacheScope.FORM_VIEW}:${viewId}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!view) {
            view = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.FORM_VIEW, {
                fk_view_id: viewId
            });
            if (view) {
                view.meta = (0, _serialize.deserializeJSON)(view.meta);
                await _NocoCache.default.set(context, `${_globals.CacheScope.FORM_VIEW}:${viewId}`, view);
            } else {
                return null;
            }
        }
        const convertedAttachment = await this.convertAttachmentType({
            banner_image_url: view == null ? void 0 : view.banner_image_url,
            logo_url: view == null ? void 0 : view.logo_url
        }, ncMeta);
        view.banner_image_url = convertedAttachment.banner_image_url || null;
        view.logo_url = convertedAttachment.logo_url || null;
        return view && new FormView(view);
    }
    static async insert(context, view, ncMeta = _Noco.default.ncMeta) {
        const insertObj = (0, _extractProps.extractProps)(view, [
            'fk_view_id',
            'base_id',
            'source_id',
            'heading',
            'subheading',
            'success_msg',
            'redirect_url',
            'redirect_after_secs',
            'email',
            'banner_image_url',
            'logo_url',
            'submit_another_form',
            'show_blank_form',
            'meta'
        ]);
        if (insertObj.meta) {
            insertObj.meta = (0, _serialize.serializeJSON)(insertObj.meta);
        }
        if (insertObj == null ? void 0 : insertObj.logo_url) {
            insertObj.logo_url = this.serializeAttachmentJSON(insertObj.logo_url);
        }
        if (insertObj == null ? void 0 : insertObj.banner_image_url) {
            insertObj.banner_image_url = this.serializeAttachmentJSON(insertObj.banner_image_url);
        }
        const viewRef = await _View.default.get(context, view.fk_view_id, ncMeta);
        if (!view.source_id) {
            insertObj.source_id = viewRef.source_id;
        }
        await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.FORM_VIEW, insertObj, true);
        return this.get(context, view.fk_view_id, ncMeta);
    }
    static async update(context, formId, body, ncMeta = _Noco.default.ncMeta) {
        const updateObj = (0, _extractProps.extractProps)(body, [
            'heading',
            'subheading',
            'success_msg',
            'redirect_url',
            'redirect_after_secs',
            'email',
            'banner_image_url',
            'logo_url',
            'submit_another_form',
            'show_blank_form',
            'meta'
        ]);
        if (updateObj == null ? void 0 : updateObj.logo_url) {
            updateObj.logo_url = this.serializeAttachmentJSON(updateObj.logo_url);
        }
        if (updateObj == null ? void 0 : updateObj.banner_image_url) {
            updateObj.banner_image_url = this.serializeAttachmentJSON(updateObj.banner_image_url);
        }
        // update meta
        const res = await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.FORM_VIEW, (0, _modelUtils.prepareForDb)(updateObj), {
            fk_view_id: formId
        });
        await _NocoCache.default.update(context, `${_globals.CacheScope.FORM_VIEW}:${formId}`, (0, _modelUtils.prepareForResponse)(updateObj));
        return res;
    }
    async getColumns(context, ncMeta = _Noco.default.ncMeta) {
        return this.columns = await _FormViewColumn.default.list(context, this.fk_view_id, ncMeta);
    }
    static async getWithInfo(context, formViewId, ncMeta = _Noco.default.ncMeta) {
        const form = await this.get(context, formViewId, ncMeta);
        await form.getColumns(context, ncMeta);
        return form;
    }
    static serializeAttachmentJSON(attachment) {
        if (attachment) {
            return (0, _serialize.serializeJSON)((0, _extractProps.extractProps)((0, _serialize.deserializeJSON)(attachment), [
                'url',
                'path',
                'title',
                'mimetype',
                'size',
                'icon'
            ]));
        }
        return attachment;
    }
    static async convertAttachmentType(formAttachments, ncMeta = _Noco.default.ncMeta) {
        try {
            if (formAttachments) {
                const promises = [];
                for(const key in formAttachments){
                    if (formAttachments[key] && typeof formAttachments[key] === 'string') {
                        formAttachments[key] = (0, _serialize.deserializeJSON)(formAttachments[key]);
                    }
                    promises.push(_models.PresignedUrl.signAttachment({
                        attachment: formAttachments[key]
                    }, ncMeta));
                }
                await Promise.all(promises);
            }
        } catch (unused) {}
        return formAttachments;
    }
    constructor(data){
        Object.assign(this, data);
    }
};
